<template>
  <a-drawer width="50%" :label-col="6" :wrapper-col="18" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- 基本资料 -->
      <a-divider orientation="left">基本资料</a-divider>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="手机号" prop="contactPhone">
            <a-input v-model="form.contactPhone" placeholder="请输入手机号（必填，用于关联用户）" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="姓名" prop="name">
            <a-input v-model="form.name" placeholder="请输入姓名" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="性别" prop="gender">
            <a-select v-model="form.gender" placeholder="请选择性别">
              <a-select-option :value="1">男</a-select-option>
              <a-select-option :value="2">女</a-select-option>
              <a-select-option :value="3">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="年龄" prop="age">
            <a-input-number v-model="form.age" placeholder="请输入年龄" :min="0" :max="150" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="身高（cm）" prop="height">
            <a-input-number v-model="form.height" placeholder="例如：170" :min="0" :max="300" :precision="2" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="体重（kg）" prop="weight">
            <a-input-number v-model="form.weight" placeholder="例如：65" :min="0" :max="500" :precision="2" style="width: 100%" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 住院与手术信息 -->
      <a-divider orientation="left">住院与手术信息</a-divider>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="住院号" prop="hospitalNo">
            <a-input v-model="form.hospitalNo" placeholder="请输入住院号" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="入院日期" prop="admissionDate">
            <a-date-picker v-model="form.admissionDate" placeholder="请选择入院日期" style="width: 100%" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="手术名称" prop="surgeryName">
            <a-input v-model="form.surgeryName" placeholder="如：胃癌根治术 / 结直肠癌手术" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="科室" prop="departmentId">
            <a-select v-model="form.departmentId" placeholder="请选择科室" style="width: 100%">
              <a-select-option v-for="dept in departmentList" :key="dept.id" :value="dept.id">
                {{ dept.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 教育与支付方式 -->
      <a-divider orientation="left">教育与支付方式</a-divider>
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="文化程度" prop="educationLevel">
            <a-select v-model="form.educationLevel" placeholder="请选择文化程度">
              <a-select-option value="小学及以下">小学及以下</a-select-option>
              <a-select-option value="初中">初中</a-select-option>
              <a-select-option value="高中/中专">高中/中专</a-select-option>
              <a-select-option value="大专">大专</a-select-option>
              <a-select-option value="本科">本科</a-select-option>
              <a-select-option value="研究生及以上">研究生及以上</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="医疗费用支付方式" prop="paymentMethod">
            <a-select v-model="form.paymentMethod" placeholder="请选择支付方式">
              <a-select-option value="城镇职工医保">城镇职工医保</a-select-option>
              <a-select-option value="城乡居民医保">城乡居民医保</a-select-option>
              <a-select-option value="商业保险">商业保险</a-select-option>
              <a-select-option value="自费">自费</a-select-option>
              <a-select-option value="其他">其他</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>

      <!-- 病史 -->
      <a-divider orientation="left">病史</a-divider>
      <a-row :gutter="24">
        <a-col :span="24">
          <a-form-model-item label="术前合并症" prop="preoperativeComorbidity">
            <a-textarea v-model="form.preoperativeComorbidity" placeholder="如：高血压、糖尿病…" :rows="3" />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="术前放化疗史" prop="preoperativeRtctHistory">
            <a-select v-model="form.preoperativeRtctHistory" placeholder="请选择">
              <a-select-option value="无">无</a-select-option>
              <a-select-option value="有（放疗）">有（放疗）</a-select-option>
              <a-select-option value="有（化疗）">有（化疗）</a-select-option>
              <a-select-option value="有（放化疗）">有（放化疗）</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="化疗周期" prop="chemotherapyCycles">
            <a-input v-model="form.chemotherapyCycles" placeholder="例如：4个周期/无" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item label="备注" prop="remark">
            <a-textarea v-model="form.remark" placeholder="请输入备注" :rows="2" />
          </a-form-model-item>
        </a-col>
      </a-row>

      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPatientInfo, addPatientInfo, updatePatientInfo } from '@/api/biz/patientInfo'
import { listDepartments } from '@/api/biz/departments'
import moment from 'moment'

export default {
  name: 'CreateForm',
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      departmentList: [],
      form: {
        id: null,
        contactPhone: null,
        name: null,
        gender: null,
        age: null,
        height: null,
        weight: null,
        hospitalNo: null,
        admissionDate: null,
        surgeryName: null,
        departmentId: null,
        educationLevel: null,
        paymentMethod: null,
        preoperativeComorbidity: null,
        preoperativeRtctHistory: null,
        chemotherapyCycles: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
        contactPhone: [
          { required: true, message: '手机号不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    this.loadDepartments()
  },
  methods: {
    /** 加载科室列表 */
    loadDepartments () {
      listDepartments({}).then(response => {
        if (response.data) {
          this.departmentList = response.data
        }
      }).catch(() => {
        this.$message.error('加载科室列表失败')
      })
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        contactPhone: null,
        name: null,
        gender: null,
        age: null,
        height: null,
        weight: null,
        hospitalNo: null,
        admissionDate: null,
        surgeryName: null,
        departmentId: null,
        educationLevel: null,
        paymentMethod: null,
        preoperativeComorbidity: null,
        preoperativeRtctHistory: null,
        chemotherapyCycles: null,
        remark: null
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd () {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加患者信息'
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : null
      getPatientInfo({ id }).then(response => {
        const data = response.data
        this.form = {
          id: data.id,
          contactPhone: data.contactPhone || data.userMobile,
          name: data.name,
          gender: data.gender,
          age: data.age,
          height: data.height,
          weight: data.weight,
          hospitalNo: data.hospitalNo,
          admissionDate: data.admissionDate ? moment(data.admissionDate) : null,
          surgeryName: data.surgeryName,
          departmentId: data.departmentId,
          educationLevel: data.educationLevel,
          paymentMethod: data.paymentMethod,
          preoperativeComorbidity: data.preoperativeComorbidity,
          preoperativeRtctHistory: data.preoperativeRtctHistory,
          chemotherapyCycles: data.chemotherapyCycles,
          remark: data.remark
        }
        this.open = true
        this.formTitle = '修改患者信息'
      })
    },
    /** 提交按钮 */
    submitForm () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          const submitData = {
            ...this.form,
            admissionDate: this.form.admissionDate ? moment(this.form.admissionDate).format('YYYY-MM-DD') : null
          }
          if (this.form.id !== undefined && this.form.id !== null) {
            updatePatientInfo(submitData).then(response => {
              this.$message.success('修改成功', 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addPatientInfo(submitData).then(response => {
              this.$message.success('新增成功', 3)
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
.bottom-control {
  margin-top: 20px;
  text-align: right;
}
</style>

